export const googleAuthSettings = {
    client_id: '503329558373-nndh2cks6bh8ss4kv1bhkjvme1be41ve.apps.googleusercontent.com',
    scope: 'openid email'
};
